{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Senṭeḍ",
    "pasteAsPlaintext": "",
    "pasteCharts": "Senṭeḍ udlifen",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "Fren akk",
    "multiSelect": "Rnu aferdis ɣer tefrayt",
    "moveCanvas": "Smutti taɣzut n usuneɣ",
    "cut": "Gzem",
    "copy": "Nɣel",
    "copyAsPng": "Nɣel ɣer tecfawit am PNG",
    "copyAsSvg": "Nɣel ɣer tecfawit am SVG",
    "copyText": "Nɣel ɣer tecfawit am uḍris",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Awi ɣer sdat",
    "sendToBack": "Awi s agilal",
    "bringToFront": "Err ɣer deffir",
    "sendBackward": "Awi ɣer deffir",
    "delete": "Kkes",
    "copyStyles": "Nɣel iɣunab",
    "pasteStyles": "Senṭeḍ iɣunab",
    "stroke": "Azizdew",
    "changeStroke": "",
    "background": "Agilal",
    "changeBackground": "",
    "fill": "Taččart",
    "strokeWidth": "Tehri n yizirig",
    "strokeStyle": "Aɣanib n tizirig",
    "strokeStyle_solid": "Aččuran",
    "strokeStyle_dashed": "S tjerriḍin",
    "strokeStyle_dotted": "S tenqiḍin",
    "sloppiness": "Astehzi",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Tiḍullest",
    "textAlign": "Areyyec n uḍris",
    "edges": "Leryuf",
    "sharp": "Yemsed",
    "round": "Imdewer",
    "arrowheads": "Ixfawen n tenccabt",
    "arrowhead_none": "Ulac",
    "arrowhead_arrow": "Taneccabt",
    "arrowhead_bar": "Afeggag",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Akerdis",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "",
    "cardinality": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Tiddi n tsefsit",
    "fontFamily": "Tawacult n tsefsiyin",
    "addWatermark": "Seddu \"Yettwaxdem s Excalidraw\"",
    "handDrawn": "Asuneɣ s ufus",
    "normal": "Amagnu",
    "code": "Tangalt",
    "small": "Meẓẓi",
    "medium": "Alemmas",
    "large": "Ameqran",
    "veryLarge": "Meqqer aṭas",
    "solid": "Aččuran",
    "hachure": "Azerreg",
    "zigzag": "",
    "crossHatch": "Azerreg anmidag",
    "thin": "Arqaq",
    "bold": "Azuran",
    "left": "Azelmaḍ",
    "center": "Talemmast",
    "right": "Ayfus",
    "extraBold": "Azuran aṭas",
    "architect": "Amasdag",
    "artist": "Anaẓur",
    "cartoonist": "Amefɣul",
    "fileTitle": "Isem n ufaylu",
    "colorPicker": "Amafran n yini",
    "canvasColors": "Yettwaseqdec di teɣzut n usuneɣ",
    "canvasBackground": "Agilal n teɣzut n usuneɣ",
    "drawingCanvas": "Taɣzut n usuneɣ",
    "clearCanvas": "",
    "layers": "Tissiyin",
    "actions": "Tigawin",
    "language": "Tutlayt",
    "liveCollaboration": "Amɛiwen s srid...",
    "duplicateSelection": "Sisleg",
    "untitled": "War azwel",
    "name": "Isem",
    "yourName": "Isem-ik (im)",
    "madeWithExcalidraw": "Yettwaxdem s Excalidraw",
    "group": "Segrew tafrayt",
    "ungroup": "Kkess asegrew i tefrayt",
    "collaborators": "Imɛiwnen",
    "you": "",
    "toggleGrid": "",
    "loadingScene": "Asali n usayes…",
    "loadScene": "",
    "align": "Reyyec",
    "alignTop": "Areyyec uksawen",
    "alignBottom": "Areyyec ukessar",
    "alignLeft": "Reyyec s azelmaḍ",
    "alignRight": "Areyyec s ayfus",
    "centerVertically": "Di tlemmast s ibeddi",
    "centerHorizontally": "Di tlemmast s uglawi",
    "distributeHorizontally": "Freq s uglawi",
    "distributeVertically": "Freq s yibeddi",
    "flipHorizontal": "Tuttya taglawant",
    "flipVertical": "Tuttya tubdidt",
    "viewMode": "Askar n tmuɣli",
    "share": "Bḍu",
    "showStroke": "Beqqeḍ amelqaḍ n yini n yizirig",
    "showBackground": "Beqqeḍ amelqaḍ n yini n ugilal",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "Asentel",
    "decreaseFontSize": "Senqes tiddi n tsefsit",
    "increaseFontSize": "Sali tiddi n tsefsit",
    "unbindText": "Serreḥ iweḍris",
    "bindText": "Arez aḍris s anagbar",
    "createContainerFromText": "",
    "link": {
      "edit": "Ẓreg aseɣwen",
      "editEmbed": "",
      "create": "Rnu asaɣ",
      "label": "Aseɣwen",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "Ẓreg izirig",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Sekkeṛ",
      "unlock": "Serreḥ",
      "lockAll": "Sekkeṛ akk",
      "unlockAll": "Serreḥ akk"
    },
    "sidebarLock": "Eǧǧ afeggag n yidis yeldi",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "followUs": "Ḍfeṛ-aɣ-d",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "Ales awennez n teɣzut n usuneɣ",
    "exportJSON": "Sifeḍ afaylu",
    "exportImage": "Sifeḍ tugna...",
    "export": "Sekles di...",
    "copyToClipboard": "Nɣel ɣer tecfawit",
    "copyLink": "Nɣel asaɣ",
    "save": "Sekles deg ufaylu amiran",
    "saveAs": "Sekles am",
    "load": "Ldi",
    "getShareableLink": "Awi-d aseɣwen n beṭṭu",
    "close": "Mdel",
    "selectLanguage": "Fren tutlayt",
    "scrollBackToContent": "Uɣal s agbur",
    "zoomIn": "Simɣur",
    "zoomOut": "Simẓi",
    "resetZoom": "Ales awennez n usemɣer",
    "menu": "Umuɣ",
    "done": "Ifukk",
    "edit": "Ẓreg",
    "undo": "Sefsex",
    "redo": "Err-d",
    "createNewRoom": "Snulfu-d taxxamt tamaynutt",
    "fullScreen": "Agdil aččuran",
    "darkMode": "Askar imsulles",
    "lightMode": "Askar afaw",
    "systemMode": "",
    "zenMode": "Askar Zen",
    "objectsSnapMode": "",
    "exitZenMode": "Ffeɣ seg uskar Zen",
    "cancel": "Sefsex",
    "clear": "Sfeḍ",
    "remove": "Kkes",
    "embed": "",
    "submit": "Azen",
    "confirm": "Sentem",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Ayagi ad isfeḍ akk taɣzut n usuneɣ. Tetḥeqqeḍ?",
    "couldNotCreateShareableLink": "D awezɣi asnulfu n useɣwen n beṭṭu.",
    "couldNotCreateShareableLinkTooBig": "D awezɣi asnulfu n useɣwen n beṭṭu. Asayes ɣezzif aṭas",
    "couldNotLoadInvalidFile": "D awezɣi asali n ufaylu armeɣtu",
    "importBackendFailed": "Takterḍ seg uɣawas n deffir ur teddi ara.",
    "cannotExportEmptyCanvas": "D awezɣi asifeḍ n teɣzut n usuneɣ tilemt.",
    "couldNotCopyToClipboard": "Ulamek anɣal ɣer tecfawit.",
    "decryptFailed": "D awezɣi tukksa n uwgelhen i yisefka.",
    "uploadedSecurly": "Asili yettwasɣelles s uwgelhen ixef s ixef, ayagi yebɣa ad d-yini belli aqeddac n Excalidraw akked medden ur zmiren ara ad ɣren agbur.",
    "loadSceneOverridePrompt": "Asali n wunuɣ uffiɣ ad isemselsi agbur-inek (m) yellan. Tebɣiḍ ad tkemmeleḍ?",
    "collabStopOverridePrompt": "Aḥbas n tɣimit ad yesefsex unuɣ-inek (m) yettwaḥerzen yakan s wudem adigan. Tetḥeqqeḍ?\n(Ma tebɣiḍ ad teǧǧeḍ unuɣ-inek (m) adigan, mdel iccer n yiminig, deg umḍiq.)",
    "imageDoesNotContainScene": "Tugna-agi tettban-d ur tesɛi ara isefka n usayes. Tesremdeḍ aseddu n usayes deg usifeḍ?",
    "cannotRestoreFromImage": "Asayes ulamek ara d-yettwarr seg ufaylu-agi n tugna",
    "invalidSceneUrl": "Ulamek taktert n usayes seg URL i d-ittunefken. Ahat mačči d tameɣtut neɣ ur tegbir ara isefka JSON n Excalidraw.",
    "invalidEncryptionKey": "Tasarut n uwgelhen isefk ad tesɛu 22 n yiekkilen. Amɛiwen srid yensa.",
    "collabOfflineWarning": "Ulac tuqqna n internet.\nIbedilen-ik ur ttwaklasen ara!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Anaw n ufaylu ur yettwasefrak ara.",
    "imageInsertError": "D awezɣi tugra n tugna. Eɛreḍ tikkelt-nniḍen ardeqqal...",
    "fileTooBig": "Afaylu meqqer aṭas. Tiddi tafellayt yurgen d {{maxSize}}.",
    "svgImageInsertError": "D awezɣi tugra n tugna SVG. Acraḍ SVG yettban-d d armeɣtu.",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "Ulamek tuqqna s aqeddac n umyalel. Ma ulac uɣilif ales asali n usebter sakin eɛreḍ tikkelt-nniḍen.",
    "collabSaveFailed": "Ulamek asekles deg uzadur n yisefka deg ugilal. Ma ikemmel wugur, isefk ad teskelseḍ afaylu s wudem adigan akken ad tetḥeqqeḍ ur tesruḥuyeḍ ara amahil-inek•inem.",
    "collabSaveFailed_sizeExceeded": "Ulamek asekles deg uzadur n yisefka deg ugilal, taɣzut n usuneɣ tettban-d temqer aṭas. Isefk ad teskelseḍ afaylu s wudem adigan akken ad tetḥeqqeḍ ur tesruḥuyeḍ ara amahil-inek•inem.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "Ayagi yezmer ad d-iglu s truẓi n<bold>Iferdisen n uḍris</bold>deg wunuɣen-inek.",
      "line3": "Ad k-nsemter ad tsexsiḍ aɣewwar-agi. Tzemreḍ ad tḍefreḍ<link>isurifen-agi</link> ɣef wamek ara txedmeḍ.",
      "line4": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Tafrayt",
    "lasso": "",
    "image": "Ger tugna",
    "rectangle": "Asrem",
    "diamond": "Ameɣṛun",
    "ellipse": "Taglayt",
    "arrow": "Taneccabt",
    "line": "Izirig",
    "freedraw": "Suneɣ",
    "text": "Aḍris",
    "lock": "Eǧǧ afecku n tefrayt yermed mbaɛd asuneɣ",
    "penMode": "Askar n yimru - gdel tanalit",
    "link": "",
    "eraser": "Sfeḍ",
    "frame": "",
    "embeddable": "",
    "laser": "",
    "autoshape": "",
    "bucketfill": "",
    "hand": "Afus (afecku n usmutti n tmuɣli)",
    "extraTools": "",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "Asrem",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "Izirig",
    "freedraw": "",
    "text": "Aḍris",
    "image": "Tugna",
    "group": "Sigrew",
    "frame": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "Tigawin n teɣzut n usuneɣ",
    "selectedShapeActions": "Tigawin n talɣa yettwafernen",
    "shapes": "Talɣiwin"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Ssit akken ad tebduḍ aṭas n tenqiḍin, zuɣer i yiwen n yizirig",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Ssit yerna zuɣer, serreḥ ticki tfukeḍ",
    "text": "Tixidest: tzemreḍ daɣen ad ternuḍ aḍris s usiti snat n tikkal anida tebɣiḍ s ufecku n tefrayt",
    "embeddable": "",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Ulamek abeqqeḍ n teskant",
    "canvasTooBig": "Taɣzut n usuneɣ tezmer ad tili temeqqer aṭas.",
    "canvasTooBigTip": "Tixidest: eɛreḍ ad tesqerbeḍ ciṭ iferdisen yembaɛaden."
  },
  "errorSplash": {
    "headingMain": "Teḍra-d tuccḍa. Eɛreḍ <button>asali n usebter tikkelt-nniḍen.</button>",
    "clearCanvasMessage": "Ma yella tulsa n usali ur tefri ara ugur, eɛreḍ <button>asfaḍ n teɣzut n usuneɣ.</button>",
    "clearCanvasCaveat": " Ayagi ad d-iglu s usṛuḥu n umahil ",
    "trackedToSentry": "Tuccḍa akked umesmagi {{eventId}} tettwasekles deg unagraw-nneɣ.",
    "openIssueMessage": "Nḥuder aṭas akken ur nseddu ara talɣut n usayes-inek (m) di tuccḍa. Ma yella asayes-inek (m) mačči d amaẓlay, ttxil-k (m) xemmem ad ḍefreḍ <button>afecku n weḍfar n yibugen.</button> Ma ulac uɣilif seddu talɣut ukessar-agi s wenɣal akked usenṭeḍ di GitHub issue.",
    "sceneContent": "Agbur n usayes:"
  },
  "shareDialog": {
    "or": "Neɣ"
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "Bdu tiɣimit",
    "button_stopSession": "Ḥbes tiɣimit",
    "desc_inProgressIntro": "Tiɣimit n umɛawen s srid tetteddu akka tura.",
    "desc_shareLink": "Bḍu aseɣwen-agi akked medden ukud tebɣiḍ ad temɛawaneḍ:",
    "desc_exitSession": "Aḥbas n tɣimit ad k (m) yesenser si texxamt, maca ad tizmireḍ ad tkemmeleḍ amahil s usayes, s wudem adigan. Ẓer belli ayagi ur yettḥaz ara imdanen-nniḍen, yerna ad izmiren ad kemmelen ad mɛawanen di tsuffeɣt-nnsen.",
    "shareTitle": "Rnu ɣer tɣimit n umɛiwen s srid n Excalidraw"
  },
  "errorDialog": {
    "title": "Tuccḍa"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "Sekles deg uḍebsi",
    "disk_details": "Sekles isefka n usayes deg ufaylu ansi ara tizmireḍ ad d-tketreḍ areḍqal.",
    "disk_button": "Sekles deg ufaylu",
    "link_title": "Aseɣwen n beṭṭu",
    "link_details": "Sifeḍ am useɣwen n tɣuri kan.",
    "link_button": "Sifeḍ deg useɣwen",
    "excalidrawplus_description": "Sekles asayes-inek•inem di tallunt n umahil Excalidraw+.",
    "excalidrawplus_button": "Sifeḍ",
    "excalidrawplus_exportError": "Ulamek asifeḍ ɣer Excalidraw+ akka tura..."
  },
  "helpDialog": {
    "blog": "Ɣeṛ ablug-nneɣ",
    "click": "ssit",
    "deepSelect": "Afran s telqey",
    "deepBoxSelect": "Afran s telqey s tnaka, yerna ad tyrewleḍ i uzuɣer",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Taneccabt izelgen",
    "curvedLine": "Izirig izelgen",
    "documentation": "Tasemlit",
    "doubleClick": "ssit snat n tikkal",
    "drag": "zuɣer",
    "editor": "Amaẓrag",
    "editLineArrowPoints": "Ẓreg tinqiḍin n yizirig/taneccabt",
    "editText": "Ẓreg aḍris/rnu tabzimt",
    "github": "Tufiḍ-d ugur? Azen-aɣ-d",
    "howto": "Ḍfer imniren-nneɣ",
    "or": "neɣ",
    "preventBinding": "Seḥbes tuqqna n tneccabin",
    "tools": "Ifecka",
    "shortcuts": "Inegzumen n unasiw",
    "textFinish": "Fak asiẓreg (amaẓrag n uḍris)",
    "textNewLine": "Rnu ajerriḍ amaynut (amaẓrag n uḍris)",
    "title": "Tallelt",
    "view": "Tamuɣli",
    "zoomToFit": "Simɣur akken ad twliḍ akk iferdisen",
    "zoomToSelection": "Simɣur ɣer tefrayt",
    "toggleElementLock": "Sekkeṛ/kkes asekker i tefrayt",
    "movePageUpDown": "Smutti asebter d asawen/akessar",
    "movePageLeftRight": "Smutti asebter s azelmaḍ/ayfus",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Sfeḍ taɣzut n usuneɣ"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "Unuɣen-inek (m) ttuwgelhnen seg yixef s ixef dɣa iqeddacen n Excalidraw werǧin ad ten-walin. ",
    "link": "Amagrad ɣef uwgelhen ixef s ixef di Excalidraw"
  },
  "stats": {
    "angle": "Tiɣmeṛt",
    "shapes": "",
    "height": "Tattayt",
    "scene": "Asayes",
    "selected": "Yettwafren",
    "storage": "Aḥraz",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "Aɣrud",
    "version": "Alqem",
    "versionCopy": "Sit ad tneɣleḍ",
    "versionNotAvailable": "Ur inuḥ ulqem",
    "width": "Tehri"
  },
  "toast": {
    "copyStyles": "Iɣunab yettwaneɣlen.",
    "copyToClipboard": "Yettwaɣel ɣer tecfawit.",
    "copyToClipboardAsPng": "{{exportSelection}} yettwanɣel ɣer tecfawit am PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Afaylu yettwasekles.",
    "fileSavedToFilename": "Yettwasekles di {filename}",
    "canvas": "taɣzut n usuneɣ",
    "selection": "tafrayt",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Afrawan",
    "black": "Aberkan",
    "white": "Amellal",
    "red": "Azeggaɣ",
    "pink": "Axuxi",
    "grape": "",
    "violet": "Aṛzaz",
    "gray": "Aɣiɣdi",
    "blue": "Azegzaw",
    "cyan": "",
    "teal": "",
    "green": "Adal",
    "yellow": "Awraɣ",
    "orange": "Ačinawi",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Tebɣiḍ ad tedduḍ ɣer Excalidraw+ deg umḍiq?",
      "menuHint": "Asifeḍ, ismenyifen, tutlayin, ..."
    },
    "defaults": {
      "menuHint": "Asifeḍ, ismenyifen, d wayen-nniḍen...",
      "center_heading": "",
      "toolbarHint": "Fren afecku tebduḍ asuneɣ!",
      "helpHint": "Inegzumen akked tallelt"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "Initen",
    "shades": "",
    "hexCode": "",
    "noShades": "",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "Sekles ar uḍebsi",
        "button": "Sekles ar uḍebsi",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
